import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceListComponent } from './invoice-list/invoice-list.component';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InvoiceItemsListComponent } from './invoice-items-list/invoice-items-list.component';
import { InvoicesRoutingModule } from './invoices-routing.module';
import { InvoiceGeneratorComponent } from './invoice-generator/invoice-generator.component';
import { InvoiceLayoutComponent } from './invoice-layout/invoice-layout.component';



@NgModule({
  declarations: [
    InvoiceListComponent,
    InvoiceItemsListComponent,
    InvoiceGeneratorComponent,
    InvoiceLayoutComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    InvoicesRoutingModule
  ]
})
export class InvoicesModule { }
